import { useTranslation } from 'react-i18next';

import Layout from '@/components/Layout/Layout';
import { useBodyClass } from '@/hooks/useBodyClass';

function ErrorPage({ error = 404 }) {
    const { t } = useTranslation();
    useBodyClass('has-background-black');

    let message = {};

    switch (error) {
        case 404:
            message = {
                title: 404,
                subtitle: t('pagina no encontrada'),
                description: t('la pagina no existe'),
            };
            break;
        case 503:
            message = {
                subtitle: t('servicio temporalmente no disponible'),
                description: t('problema al cargar el contenido'),
            };
            break;
    }

    return (
        <Layout>
            <div className="error-page has-text-white">
                <div className="wrapper">
                    <div className="flow">
                        <h1>{message.title}</h1>
                        <h2 className="is-size-2 has-text-weight-semibold">{message.subtitle}</h2>
                        <p className="has-text-weight-light">{message.description}</p>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default ErrorPage;
